import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog from "../dialog";
import * as main from "../main";
import * as navigation from "../navigation";
import * as viewmode from "../viewmode";

/**
 * Refreshes the grid 
 */
export function refreshGrid(gridname: string): void {

    const grid = $("#" + gridname).data("kendoGrid");

    if (grid != undefined) {
        grid.dataSource.read();
    }
}

export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("UserRole/Edit?userId=" + dataItem.UserID + "&nodeId=" + dataItem.NodeID + "&breadcrumbLabel=" + dataItem.FullName);
}

export function copyItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Prevent default behaviour
    e.preventDefault();

    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // select the item
    const dataItem = this.dataItem($(e.currentTarget).closest("tr"));

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("UserRole/Copy?userId=" + dataItem.UserID + "&nodeId=" + dataItem.NodeID + "&breadcrumbLabel=" + dataItem.FullName);
}

export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as UserRoleGridVM;
        removeItem(dataItem.UserID, dataItem.NodeID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

export function removeItem(userId: number, nodeId: number): void {
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserRole/Delete"),
        data: { userId: userId, nodeId: nodeId },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {

            refreshGrid("RolesGrid");

            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}

export function checkboxTemplate(userId: number, nodeId: number, roleId: number, isChecked: boolean, validUntil: string): string {
    let checked = "";
    if (isChecked)
    {
        checked = "checked ";
    }    

    var templateHtml = "<div style='text-align: center;'>" +
                       "<input type='checkbox' " +
                       "name='" + userId + "_" + nodeId + "_" + roleId + "' " +
                       checked +
                       "onChange='PreCom.Modules.userRole.onChangeUserRoleGranted(event)' />" +
                       (validUntil ? "<br>" + validUntil : "") +
                       "</div>";

    return templateHtml;
}

export function onChangeUserRoleGranted(e: Event): void {
    const checkbox = e.target as HTMLInputElement;
    const [userId, nodeId, roleId] = checkbox.name.split("_").map(Number);
    var granted = checkbox.checked;

    $.ajax({
        type: "POST",
        url: appsettings.getUrl("UserRole/Update_UserRole"),
        data: { userId: userId, nodeId: nodeId, roleId: roleId, granted: granted },
        dataType: 'json',
        success: function (responseData: responseModel | undefined | null) {
            if (responseData != undefined && responseData != null && !responseData.Succesfully) {
                main.makeResultMessage(responseData);
            }
        }
    });
}
